import React from "react";
import { Crown } from "lucide-react";

export default function Brand({ size = "md", subtitle = true }) {
  const titleSize =
    size === "lg" ? "text-5xl sm:text-6xl" : size === "sm" ? "text-xl" : "text-3xl";
  return (
    <div className="flex items-center gap-3" data-testid="brand">
      <span className="inline-flex items-center justify-center w-10 h-10 rounded-full border border-primary/40 bg-background">
        <Crown className="w-5 h-5 text-primary" strokeWidth={1.5} />
      </span>
      <div className="flex flex-col leading-tight">
        <span className={`font-display ${titleSize} tracking-tight`}>
          King&rsquo;s <span className="gold-text">Café</span>
        </span>
        {subtitle && (
          <span className="text-[11px] uppercase tracking-[0.25em] text-muted-foreground">
            Mursko Središće
          </span>
        )}
      </div>
    </div>
  );
}
